<ng-template #content let-modal>
  <div class="tw-p-4 tw-shadow-lg" ngbAutoFocus>
    <div class="tw-flex tw-flex-col tw-gap-3">
      <div>
        <div class="tw-text-lg tw-font-bold">{{ appAnnounce()?.header }}</div>

        <div>
          @if (appAnnounce()?.body; as body) {
            <div>{{ body }}</div>
          }

          @if (appAnnounce()?.template; as template) {
            <div [ngTemplateOutlet]="template"></div>
          }
        </div>
      </div>

      <div>
        <button
          type="button"
          class="tw-w-full tw-rounded-lg tw-bg-secondary tw-px-3 tw-py-1.5 tw-text-lg tw-font-bold tw-text-secondary-content tw-transition-all focus:tw-ring-4 active:tw-opacity-80"
          (click)="modal.close('OK')"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</ng-template>
